import React, {type ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

import {useDragOver} from './useDragOver';

type TableEditorColumnSectionProps = {
  children: ReactNode;
  onDrop: (visible: boolean, pinned: boolean) => void;
  pinned?: boolean;
  visible?: boolean;
};

export function TableEditorColumnSection({
  children,
  onDrop,
  pinned,
  visible,
}: TableEditorColumnSectionProps) {
  const {getDraggingProps, isDraggingOver} = useDragOver({
    onDrop() {
      // If the user manages to drop something into the column section, make
      // sure it gets moved, based on the visible/pinned state:
      onDrop(Boolean(visible), Boolean(pinned));
    },
  });

  const cls = twMerge(
    'border-b border-wb-border px-8 py-8 last:border-0 transition-all',
    // Change the bg color to indicate that the user is holding the element
    // over a drop target:
    isDraggingOver && 'bg-moon-100 dark:bg-moon-850',
    // visible but not pinned section should flex-grow to fill remaining height
    visible && !pinned && 'grow'
  );
  return (
    <div className={cls} role="group" {...getDraggingProps()}>
      {children}
    </div>
  );
}
